module.exports = __webpack_public_path__ + "img/Ident-1.4fceaf59.png";